import styled from 'styled-components';

import { fontSize, FontSizes, FontWeights, minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.div`
	grid-column-start: 1;
	grid-column-end: 4;
	margin: 0 0 28px;
	width: 100%;
	text-align: center;

	${minWidth('tablet')} {
		grid-column-start: 2;
		margin: 28px 0;
	}
`;

export const Headline = styled(Text).attrs({
	size: FontSizes.xl,
	align: 'center',
	weight: FontWeights.Medium,
	el: 'h2',
})<{ $span?: boolean }>`
	${minWidth('tablet')} {
		${p => (p.$span ? 'grid-column: span 2;' : '')}
		${fontSize(FontSizes['2xl'])}
	}
`;
export const OfferForText = styled(Text).attrs({
	size: FontSizes.sm,
	align: 'end',
})`
	${minWidth('tablet')} {
		${fontSize(FontSizes.base)};
	}
`;
